var render = function render(){var _vm=this,_c=_vm._self._c;return _c('EqsSkeleton',{staticClass:"internal-pdf-view",attrs:{"loading":_vm.loadingPreview,"type":"image"}},[_c('object',{staticClass:"fill-width",staticStyle:{"height":"100%"},attrs:{"data":_vm.pdfUrl,"type":"application/pdf"}},[_c('embed',{attrs:{"src":_vm.pdfUrl,"type":"application/pdf"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }